import Slider from './components/Slider.vue';

const bmiWidgetApp = {
    components: {
        Slider
    },
    data() {
        return {
            dataHeavyunderweightlabel: 'Ernstig ondergewicht',
            dataUnderweightlabel: 'Ondergewicht',
            dataNormalweightlabel: 'Normaal gewicht',
            dataSomeoverweightlabel: 'Enig overgewicht',
            dataOverweightlabel: 'Overgewicht',
            dataHeavyoverweightlabel: 'Ernstig overgewicht',

            bodyLength: 175,
            bodyWeight: 75,
        };
    },
    computed: {
        bmi() {
            return (this.bodyWeight / Math.pow(this.bodyLength / 100, 2)).toFixed(1);
        },
        bmiString() {
            switch (true) {
                case this.bmi <= 17:
                    return this.dataHeavyunderweightlabel;
                case this.bmi <= 18.5:
                    return this.dataUnderweightlabel;
                case this.bmi <= 25:
                    return this.dataNormalweightlabel;
                case this.bmi <= 30:
                    return this.dataSomeoverweightlabel;
                case this.bmi <= 35:
                    return this.dataOverweightlabel;
                case this.bmi > 35:
                    return this.dataHeavyoverweightlabel;
                default:
                    return this.dataNormalweightlabel;
            }
        },
        bmiClass() {
            switch (true) {
                case this.bmi <= 17:
                    return 'has-background-blue';
                case this.bmi <= 18.5:
                    return 'has-background-turquoise';
                case this.bmi <= 25:
                    return 'has-background-green';
                case this.bmi <= 30:
                    return 'has-background-yellow has-text-black';
                case this.bmi <= 35:
                    return 'has-background-orange';
                case this.bmi > 35:
                    return 'has-background-red';
                default:
                    return 'has-background-green';
            }
        },
    },
    mounted() {
        if (this.$el.dataset.heavyunderweightlabel) this.dataHeavyunderweightlabel = this.$el.dataset.heavyunderweightlabel;
        if (this.$el.dataset.underweightlabel) this.dataUnderweightlabel = this.$el.dataset.underweightlabel;
        if (this.$el.dataset.normalweightlabel) this.dataNormalweightlabel = this.$el.dataset.normalweightlabel;
        if (this.$el.dataset.someoverweightlabel) this.dataSomeoverweightlabel = this.$el.dataset.someoverweightlabel;
        if (this.$el.dataset.overweightlabel) this.dataOverweightlabel = this.$el.dataset.overweightlabel;
        if (this.$el.dataset.heavyoverweightlabel) this.dataHeavyoverweightlabel = this.$el.dataset.heavyoverweightlabel;
    },
};

export default bmiWidgetApp;
